import React from "react";
import { withTranslation } from "react-i18next";
import { InputFactory } from "../Factories/Input";
import { ProfileInputWrap } from "./index";

const addressFields = [
  { name: "address_1", type: "text", label: "Address Line 1" },
  { name: "address_2", type: "text", label: "Address Line 2" },
  { name: "town", type: "text", label: "Town" },
  { name: "city", type: "text", label: "City" },
  { name: "postcode", type: "text", label: "Postcode" },
  { name: "country", type: "select", label: "Country" },
];

class Address extends React.Component<any, any> {
  constructor(props: Readonly<any> | any) {
    super(props);
    this.state = { showUseExisting: true, useExisting: true, address: {} };
  }

  render() {
    const { value: address = {}, name, placeholder, className, disabled, status, t, onIonChange, onIonChangeSupporting, ...addressProps } = this.props;
    const { useExisting } = this.state;

    return (
      <div className={[className, !disabled ? "ion-padding" : null].filter(Boolean).join(" ")} {...addressProps}>
        {!disabled && (
          <ProfileInputWrap type="checkbox">
            <InputFactory type="checkbox" name="use_exiting_address" value={useExisting} placeholder={t("useExistingAddress")} onClick={this.toggleUseExisting} />
          </ProfileInputWrap>
        )}

        {useExisting || disabled ? (
          <InputFactory
            type="text"
            value={
              Object.values(address || {})
                .filter((line) => line)
                .join(", ") || "―"
            }
            disabled={true}
          />
        ) : (
          addressFields.map((field, key) => {
            return (
              <ProfileInputWrap key={key} type={field.type} label={field.label} className="ion-margin-vertical">
                <InputFactory
                  name={field.name}
                  type={field.type}
                  placeholder={field.label}
                  disabled={disabled}
                  value={address?.[field.name]}
                  optionsFrom={field.type === "select" ? "countries" : undefined}
                  className="input__input"
                  onIonChange={(e: any) => this.onChange(e)}
                />
              </ProfileInputWrap>
            );
          })
        )}
      </div>
    );
  }

  componentDidMount() {
    if (!this.props.value) {
      this.setState({ showUseExisting: false, useExisting: false });
    }
  }

  onChange = (e: any) => {
    const address = this.props.value || {};

    if (typeof e.detail.value !== "undefined") {
      let value;
      let name = this.props.name;

      if (this.props.returns === "object") {
        address[e.target.name] = e.detail.value;
        value = address;
      } else {
        name = `${name}_${e.target.name}`;
        value = e.detail.value;
      }

      const ionEvent = new CustomEvent("ionChange", {
        detail: {
          name,
          value,
        },
      });

      this.props.onIonChange?.(ionEvent);
    }
  };

  toggleUseExisting = () => {
    this.setState({ useExisting: !this.state.useExisting });
  };
}
export default withTranslation()(Address);
